import React from 'react';
import { Link } from 'react-router-dom';
import { FiEdit, FiTrash2, FiEye, FiList, FiPlus, FiCopy, FiRefreshCcw , FiMessageSquare, FiCheck, FiX} from 'react-icons/fi';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const ActionIcon = ({ tooltip, icon: Icon, onClick, to, color = '#64748b', hoverColor }) => {
  const content = (
    <OverlayTrigger overlay={<Tooltip>{tooltip}</Tooltip>}>
      <span className="action-icon-btn" style={{ cursor: 'pointer' }}>
        <Icon size={18} style={{ color }} />
      </span>
    </OverlayTrigger>
  );

  if (to) {
    return <Link to={to} onClick={onClick}>{content}</Link>;
  }
  return <span onClick={onClick}>{content}</span>;
};

export const EditIcon = ({ onClick, tooltip = "Edit" }) => (
  <ActionIcon tooltip={tooltip} icon={FiEdit} onClick={onClick} color="#64748b" />
);

export const DeleteIcon = ({ onClick, tooltip = "Delete" }) => (
  <ActionIcon tooltip={tooltip} icon={FiTrash2} onClick={onClick} color="#64748b" />
);

export const ViewIcon = ({ onClick, to, tooltip = "View" }) => (
  <ActionIcon tooltip={tooltip} icon={FiEye} onClick={onClick} to={to} color="#64748b" />
);

export const ManageIcon = ({ onClick, to, tooltip = "Manage" }) => (
  <ActionIcon tooltip={tooltip} icon={FiList} onClick={onClick} to={to} color="#64748b" />
);

export const AddIcon = ({ onClick, to, tooltip = "Add" }) => (
  <ActionIcon tooltip={tooltip} icon={FiPlus} onClick={onClick} to={to} color="#64748b" />
);
export const CopyLinkIcon = ({ onClick, to, tooltip = "Copy Link" }) => (
  <ActionIcon tooltip={tooltip} icon={FiCopy} onClick={onClick} to={to} color="#64748b" />
);
export const RestoreIcon = ({ onClick, to, tooltip = "Restore" }) => (
  <ActionIcon tooltip={tooltip} icon={FiRefreshCcw} onClick={onClick} to={to} color="#64748b" />
);
export const CommentIcon = ({ onClick, to, tooltip = "Comment" }) => (
  <ActionIcon tooltip={tooltip} icon={FiMessageSquare} onClick={onClick} to={to} color="#64748b" />
);

export const CheckIcon = ({ onClick, tooltip = "Save", color = "#198754" }) => (
  <ActionIcon tooltip={tooltip} icon={FiCheck} onClick={onClick} color={color} />
);

export const XIcon = ({ onClick, tooltip = "Cancel", color = "#dc3545" }) => (
  <ActionIcon tooltip={tooltip} icon={FiX} onClick={onClick} color={color} />
);
export default ActionIcon;
